import * as Yup from "yup";

export const TableConstants = {
  HEADERS: {
    CONTACTS_HEADER: "Contacts",
    DOCUMENTS_HEADER: "Documents",
    NOTES_HEADER: "Notes",
  },
  KEYS: {
    CONTACTS_KEY: "1",
    DOCUMENTS_KEY: "2",
    NOTES_KEY: "3",
  },
};

export const deleteFormSchema = Yup.object({
  archiveReason: Yup.string().trim().required("Required for deletion"),
});
